module.exports = __webpack_public_path__ + "img/IMG_9700.68154349.jpeg";